/** 判斷旅遊資訊是否為申根國家 */
export enum TravelSchengen {
    Yes = '1',
    No = '0'
}
